/**
 * A basic implementation of a content display toggle that behaves similarly to
 * the Bootstrap Collapse component. Example usage (BYO visibility CSS):
 *
 * <button type="button" data-toggle="collapse" data-active-class="expanded" data-target="#content" aria-controls="#content">
 *   <span data-collapse-text="Hide">Show</span>
 * </button>
 * <div id="content" aria-hidden="true">My toggled content</div>
 */
export default () => {
  window.addEventListener(
    "click",
    e => {
      const el = e.target.closest('[data-toggle="collapse"]')
      if (el) {
        e.preventDefault()
        collapse(el, el.dataset.target, el.dataset.activeClass || "active")
      }
    },
    false
  )

  const collapse = (triggerEl, selector, activeClass) => {
    const show = !triggerEl.classList.contains(activeClass)
    triggerEl.classList.toggle(activeClass, show)
    triggerEl.setAttribute("aria-expanded", show ? "true" : "false")

    const textNode = triggerEl.querySelector("[data-collapse-text]")

    if (textNode) {
      const text = textNode.innerText
      textNode.innerText = textNode.getAttribute("data-collapse-text")
      textNode.setAttribute("data-collapse-text", text)
    }

    const targets = Array.from(document.querySelectorAll(selector))
    targets.forEach(target => {
      target.classList.toggle("show", show)
      target.setAttribute("aria-hidden", show ? "false" : "true")
    })
  }
}
